import React, { memo } from 'react'

import { Icon, LayoutSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import { iconSizeNav } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function Header({ isOpen, handleToggleSidebar }) {
  const t = useTranslation()

  return (
    <div
      role="button"
      tabIndex={0}
      className="sidebar__header"
      onClick={handleToggleSidebar}
    >
      {!isOpen && (
        <span className="sidebar__header-icon">
          <Icon
            svgComponent={LayoutSidebar}
            color="dark"
            size={iconSizeNav}
            notSpaced
          />
        </span>
      )}
      {isOpen && (
        <>
          <span className="sidebar__header-title cgt-heading-50">{t('sidebar.header.title')}</span>
          <Icon
            className="sidebar__header-trail"
            svgComponent={LayoutSidebar}
            color="dark"
            size={iconSizeNav}
            notSpaced
          />
        </>
      )}
    </div>
  )
}

Header.propTypes = {
  isOpen: bool.isRequired,
  handleToggleSidebar: func.isRequired,
}

export default memo(Header)
